module.exports = {
  title: 'Fourier Visualizer with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2023-09-21',
  slug: 'fourier-visualizer',
  tags: ['skia', 'gesture-handler'],
};
